import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  K: () => (/* binding */ IconSustainableNaturalDye)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/IconSustainableNaturalDye.tsx


const IconSustainableNaturalDye = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-sustainable-natural-dye-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("circle", { cx: 16, cy: 16, r: 15.5, stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M17.3569 15.2536L17.7163 14.906L17.7163 14.906L17.3569 15.2536ZM15.9843 24.5298L15.4856 24.494C15.4713 24.6926 15.5763 24.8808 15.7529 24.973C15.9294 25.0652 16.1439 25.0438 16.2987 24.9186L15.9843 24.5298ZM12.87 11.5891L12.5857 12.0003L12.5857 12.0003L12.87 11.5891ZM9.00545 8.51422L9.35691 8.15859C9.22339 8.02664 9.02722 7.98059 8.84893 8.03935C8.67065 8.09811 8.5403 8.25178 8.5114 8.43726L9.00545 8.51422ZM8.16842 12.4007L7.68289 12.2813L7.68289 12.2813L8.16842 12.4007ZM7.43279 20.322L7.91942 20.2072L7.91942 20.2072L7.43279 20.322ZM13.1406 25.4205L13.1134 25.9198C13.2515 25.9273 13.3865 25.8773 13.4863 25.7817C13.5862 25.6861 13.642 25.5534 13.6405 25.4151L13.1406 25.4205ZM12 16L12.3624 15.6556C12.1994 15.4841 11.9384 15.4503 11.7371 15.5747C11.5358 15.6991 11.4493 15.9477 11.5298 16.1702L12 16ZM16.9975 15.6012C18.1717 16.8154 18.4055 18.4761 18.0435 20.1112C17.6798 21.7542 16.729 23.2844 15.6699 24.141L16.2987 24.9186C17.5505 23.9062 18.612 22.1696 19.0199 20.3273C19.4294 18.4771 19.1941 16.4342 17.7163 14.906L16.9975 15.6012ZM12.5857 12.0003C13.9943 12.9742 15.3933 13.9422 16.9975 15.6012L17.7163 14.906C16.0383 13.1707 14.5684 12.1554 13.1544 11.1778L12.5857 12.0003ZM8.65398 8.86985C10.0456 10.2452 11.3226 11.1271 12.5857 12.0003L13.1544 11.1778C11.8917 10.3048 10.68 9.46616 9.35691 8.15859L8.65398 8.86985ZM8.65395 12.5202C8.96599 11.2514 9.29024 9.93441 9.49949 8.59118L8.5114 8.43726C8.30993 9.73058 7.99662 11.0057 7.68289 12.2813L8.65395 12.5202ZM7.91942 20.2072C7.35835 17.8302 7.96836 15.3076 8.65395 12.5202L7.68289 12.2813C7.0113 15.0118 6.31952 17.782 6.94617 20.4369L7.91942 20.2072ZM13.1677 24.9213C10.9505 24.8008 8.57894 23.0013 7.91942 20.2072L6.94617 20.4369C7.70342 23.6451 10.4354 25.7743 13.1134 25.9198L13.1677 24.9213ZM13.6405 25.4151C13.6275 24.2114 13.5575 22.4372 13.3817 20.6607C13.207 18.8958 12.924 17.0839 12.4701 15.8299L11.5298 16.1702C11.9386 17.2995 12.213 19.0057 12.3865 20.7592C12.5589 22.501 12.6278 24.2453 12.6406 25.4259L13.6405 25.4151ZM11.6375 16.3444C12.2792 17.0198 13.2544 18.2334 14.066 19.6515C14.8831 21.079 15.5 22.6544 15.5 24.0692H16.5C16.5 22.3967 15.7835 20.6391 14.9339 19.1548C14.0789 17.6609 13.0541 16.3836 12.3624 15.6556L11.6375 16.3444ZM15.5 24.0692C15.5 24.2222 15.495 24.3635 15.4856 24.494L16.483 24.5656C16.4942 24.4092 16.5 24.2439 16.5 24.0692H15.5Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M23.6247 18.5247L24.1215 18.5812L24.1215 18.5812L23.6247 18.5247ZM16.9995 23.4795L16.6047 23.1728C16.4863 23.3251 16.4662 23.5319 16.5529 23.7043C16.6396 23.8766 16.8177 23.9837 17.0105 23.9794L16.9995 23.4795ZM23.6011 12.7316L24.0993 12.6897L23.6011 12.7316ZM23.5179 7.79373L24.0158 7.83896C24.0328 7.65201 23.9437 7.4713 23.785 7.37103C23.6263 7.27077 23.4248 7.26783 23.2632 7.36344L23.5179 7.79373ZM19.9857 9.61831L19.7692 9.1676L19.7692 9.1676L19.9857 9.61831ZM14.5912 12.8153L14.2595 12.4411C14.1473 12.5406 14.0856 12.6853 14.0916 12.8352C14.0976 12.9851 14.1705 13.1243 14.2903 13.2146L14.5912 12.8153ZM17.3568 15.2535L17.7162 14.9059L17.7162 14.9059L17.3568 15.2535ZM17.9126 15.948L17.4941 16.2217C17.5739 16.3436 17.7028 16.4246 17.8471 16.4437C17.9915 16.4627 18.137 16.4179 18.2456 16.3209L17.9126 15.948ZM20.079 13.5999L20.5739 13.6713C20.6072 13.4399 20.4759 13.2164 20.2576 13.1329C20.0392 13.0494 19.7922 13.1284 19.6627 13.323L20.079 13.5999ZM18.6811 18.2688L18.2286 18.0561C18.1916 18.1348 18.1758 18.2217 18.1827 18.3083L18.6811 18.2688ZM23.1279 18.4682C22.9654 19.8978 22.122 21.002 20.9549 21.7697C19.7817 22.5415 18.3103 22.9506 16.9885 22.9797L17.0105 23.9794C18.5022 23.9466 20.1601 23.4896 21.5045 22.6052C22.8551 21.7167 23.9176 20.3743 24.1215 18.5812L23.1279 18.4682ZM23.1029 12.7736C23.2466 14.48 23.3887 16.1753 23.1279 18.4682L24.1215 18.5812C24.3943 16.1827 24.2436 14.4027 24.0993 12.6897L23.1029 12.7736ZM23.0199 7.74851C22.843 9.69706 22.974 11.2435 23.1029 12.7736L24.0993 12.6897C23.9705 11.16 23.8476 9.6915 24.0158 7.83896L23.0199 7.74851ZM20.2022 10.069C21.3799 9.50336 22.6027 8.91641 23.7726 8.22402L23.2632 7.36344C22.1368 8.03011 20.9533 8.59888 19.7692 9.1676L20.2022 10.069ZM14.9229 13.1894C16.3529 11.9217 18.2049 11.0283 20.2022 10.069L19.7692 9.1676C17.8013 10.1128 15.8135 11.0636 14.2595 12.4411L14.9229 13.1894ZM14.2903 13.2146C15.1475 13.8604 16.0358 14.6067 16.9974 15.6011L17.7162 14.9059C16.7121 13.8675 15.7829 13.0871 14.892 12.4159L14.2903 13.2146ZM16.9974 15.6011C17.1881 15.7983 17.353 16.0059 17.4941 16.2217L18.331 15.6742C18.1552 15.4055 17.9508 15.1485 17.7162 14.9059L16.9974 15.6011ZM18.2456 16.3209C19.144 15.5184 19.9672 14.6706 20.4953 13.8769L19.6627 13.323C19.2051 14.0107 18.4564 14.7918 17.5795 15.5751L18.2456 16.3209ZM19.5841 13.5286C19.4289 14.6053 18.9957 16.4241 18.2286 18.0561L19.1336 18.4815C19.9518 16.7409 20.4079 14.8226 20.5739 13.6713L19.5841 13.5286ZM18.1827 18.3083C18.3174 20.0087 17.6245 21.86 16.6047 23.1728L17.3944 23.7863C18.5346 22.3185 19.3378 20.2265 19.1795 18.2293L18.1827 18.3083Z", fill: "#00174F" })] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-sustainable-natural-dye-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("circle", { cx: 16, cy: 16, r: 15.5, stroke: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M17.3569 15.2536L17.7163 14.906L17.7163 14.906L17.3569 15.2536ZM15.9843 24.5298L15.4856 24.494C15.4713 24.6926 15.5763 24.8808 15.7529 24.973C15.9294 25.0652 16.1439 25.0438 16.2987 24.9186L15.9843 24.5298ZM12.87 11.5891L12.5857 12.0003L12.5857 12.0003L12.87 11.5891ZM9.00545 8.51422L9.35691 8.15859C9.22339 8.02664 9.02722 7.98059 8.84893 8.03935C8.67065 8.09811 8.5403 8.25178 8.5114 8.43726L9.00545 8.51422ZM8.16842 12.4007L7.68289 12.2813L7.68289 12.2813L8.16842 12.4007ZM7.43279 20.322L7.91942 20.2072L7.91942 20.2072L7.43279 20.322ZM13.1406 25.4205L13.1134 25.9198C13.2515 25.9273 13.3865 25.8773 13.4863 25.7817C13.5862 25.6861 13.642 25.5534 13.6405 25.4151L13.1406 25.4205ZM12 16L12.3624 15.6556C12.1994 15.4841 11.9384 15.4503 11.7371 15.5747C11.5358 15.6991 11.4493 15.9477 11.5298 16.1702L12 16ZM16.9975 15.6012C18.1717 16.8154 18.4055 18.4761 18.0435 20.1112C17.6798 21.7542 16.729 23.2844 15.6699 24.141L16.2987 24.9186C17.5505 23.9062 18.612 22.1696 19.0199 20.3273C19.4294 18.4771 19.1941 16.4342 17.7163 14.906L16.9975 15.6012ZM12.5857 12.0003C13.9943 12.9742 15.3933 13.9422 16.9975 15.6012L17.7163 14.906C16.0383 13.1707 14.5684 12.1554 13.1544 11.1778L12.5857 12.0003ZM8.65398 8.86985C10.0456 10.2452 11.3226 11.1271 12.5857 12.0003L13.1544 11.1778C11.8917 10.3048 10.68 9.46616 9.35691 8.15859L8.65398 8.86985ZM8.65395 12.5202C8.96599 11.2514 9.29024 9.93441 9.49949 8.59118L8.5114 8.43726C8.30993 9.73058 7.99662 11.0057 7.68289 12.2813L8.65395 12.5202ZM7.91942 20.2072C7.35835 17.8302 7.96836 15.3076 8.65395 12.5202L7.68289 12.2813C7.0113 15.0118 6.31952 17.782 6.94617 20.4369L7.91942 20.2072ZM13.1677 24.9213C10.9505 24.8008 8.57894 23.0013 7.91942 20.2072L6.94617 20.4369C7.70342 23.6451 10.4354 25.7743 13.1134 25.9198L13.1677 24.9213ZM13.6405 25.4151C13.6275 24.2114 13.5575 22.4372 13.3817 20.6607C13.207 18.8958 12.924 17.0839 12.4701 15.8299L11.5298 16.1702C11.9386 17.2995 12.213 19.0057 12.3865 20.7592C12.5589 22.501 12.6278 24.2453 12.6406 25.4259L13.6405 25.4151ZM11.6375 16.3444C12.2792 17.0198 13.2544 18.2334 14.066 19.6515C14.8831 21.079 15.5 22.6544 15.5 24.0692H16.5C16.5 22.3967 15.7835 20.6391 14.9339 19.1548C14.0789 17.6609 13.0541 16.3836 12.3624 15.6556L11.6375 16.3444ZM15.5 24.0692C15.5 24.2222 15.495 24.3635 15.4856 24.494L16.483 24.5656C16.4942 24.4092 16.5 24.2439 16.5 24.0692H15.5Z", fill: "#00174F" }), (0,jsx_runtime.jsx)("path", { d: "M23.6247 18.5247L24.1215 18.5812L24.1215 18.5812L23.6247 18.5247ZM16.9995 23.4795L16.6047 23.1728C16.4863 23.3251 16.4662 23.5319 16.5529 23.7043C16.6396 23.8766 16.8177 23.9837 17.0105 23.9794L16.9995 23.4795ZM23.6011 12.7316L24.0993 12.6897L23.6011 12.7316ZM23.5179 7.79373L24.0158 7.83896C24.0328 7.65201 23.9437 7.4713 23.785 7.37103C23.6263 7.27077 23.4248 7.26783 23.2632 7.36344L23.5179 7.79373ZM19.9857 9.61831L19.7692 9.1676L19.7692 9.1676L19.9857 9.61831ZM14.5912 12.8153L14.2595 12.4411C14.1473 12.5406 14.0856 12.6853 14.0916 12.8352C14.0976 12.9851 14.1705 13.1243 14.2903 13.2146L14.5912 12.8153ZM17.3568 15.2535L17.7162 14.9059L17.7162 14.9059L17.3568 15.2535ZM17.9126 15.948L17.4941 16.2217C17.5739 16.3436 17.7028 16.4246 17.8471 16.4437C17.9915 16.4627 18.137 16.4179 18.2456 16.3209L17.9126 15.948ZM20.079 13.5999L20.5739 13.6713C20.6072 13.4399 20.4759 13.2164 20.2576 13.1329C20.0392 13.0494 19.7922 13.1284 19.6627 13.323L20.079 13.5999ZM18.6811 18.2688L18.2286 18.0561C18.1916 18.1348 18.1758 18.2217 18.1827 18.3083L18.6811 18.2688ZM23.1279 18.4682C22.9654 19.8978 22.122 21.002 20.9549 21.7697C19.7817 22.5415 18.3103 22.9506 16.9885 22.9797L17.0105 23.9794C18.5022 23.9466 20.1601 23.4896 21.5045 22.6052C22.8551 21.7167 23.9176 20.3743 24.1215 18.5812L23.1279 18.4682ZM23.1029 12.7736C23.2466 14.48 23.3887 16.1753 23.1279 18.4682L24.1215 18.5812C24.3943 16.1827 24.2436 14.4027 24.0993 12.6897L23.1029 12.7736ZM23.0199 7.74851C22.843 9.69706 22.974 11.2435 23.1029 12.7736L24.0993 12.6897C23.9705 11.16 23.8476 9.6915 24.0158 7.83896L23.0199 7.74851ZM20.2022 10.069C21.3799 9.50336 22.6027 8.91641 23.7726 8.22402L23.2632 7.36344C22.1368 8.03011 20.9533 8.59888 19.7692 9.1676L20.2022 10.069ZM14.9229 13.1894C16.3529 11.9217 18.2049 11.0283 20.2022 10.069L19.7692 9.1676C17.8013 10.1128 15.8135 11.0636 14.2595 12.4411L14.9229 13.1894ZM14.2903 13.2146C15.1475 13.8604 16.0358 14.6067 16.9974 15.6011L17.7162 14.9059C16.7121 13.8675 15.7829 13.0871 14.892 12.4159L14.2903 13.2146ZM16.9974 15.6011C17.1881 15.7983 17.353 16.0059 17.4941 16.2217L18.331 15.6742C18.1552 15.4055 17.9508 15.1485 17.7162 14.9059L16.9974 15.6011ZM18.2456 16.3209C19.144 15.5184 19.9672 14.6706 20.4953 13.8769L19.6627 13.323C19.2051 14.0107 18.4564 14.7918 17.5795 15.5751L18.2456 16.3209ZM19.5841 13.5286C19.4289 14.6053 18.9957 16.4241 18.2286 18.0561L19.1336 18.4815C19.9518 16.7409 20.4079 14.8226 20.5739 13.6713L19.5841 13.5286ZM18.1827 18.3083C18.3174 20.0087 17.6245 21.86 16.6047 23.1728L17.3944 23.7863C18.5346 22.3185 19.3378 20.2265 19.1795 18.2293L18.1827 18.3083Z", fill: "#00174F" })] })));
};

})();

var __webpack_exports__IconSustainableNaturalDye = __webpack_exports__.K;
export { __webpack_exports__IconSustainableNaturalDye as IconSustainableNaturalDye };
